import * as React from 'react'
import axios from 'axios';
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'

export class DynamicCompetition extends React.PureComponent<DynamicCompetition.Props, DynamicCompetition.State> {
  public static sectionId = 'comp';

  constructor(props) {
    super(props);

    let popup: DynamicCompetition.State["popup"] = "none";
    if (window.location.href.includes("popup=thanks")) {
      popup = "thanks"
    }
    if (window.location.href.includes("popup=closed")) {
      popup = "closed"
    }

    this.state = {
      popup: popup,
      acceptsMarketing: false,
      form: {},
    }
  }

  public componentDidMount () {
    const script = document.createElement("script");
    script.src = "https://news.helenkaminski.com/resources/sharing/embed.js?sharing=lp-embed&domain=news.helenkaminski.com&id=4UEI-4C4%2Faje%22";
    script.async = true;

    document.getElementById("dynamic-competition").appendChild(script);
  }

  public renderPopup = (title: string, content: string) => (
    <div className={`fixed inset-0 z-40 items-center md:items-start justify-center flex`} role="dialog">
      <div className={'cursor-pointer absolute bg-black opacity-50 inset-0 z-40'} />
      <div className={'w-full mx-3-2 md:mt-25-5 md:max-w-popup z-50'}>
        <div className={'bg-white relative w-full'}>
          <div className={'absolute right-0 top-0 h-4 w-4 flex items-center justify-center'}>
            <Snippets.Button
              colour={'blank'}
              className={'underline'}
              type={'button'}
              title={'Close popup'}
              onClick={() => this.setState({ popup: "none" })}
            >
              <Snippets.Icon name={'cross'} height={14} width={14} />
            </Snippets.Button>
          </div>

          <div className={'w-full py-3-6 md:py-8-8 px-2-1 md:px-15'}>
            <div className={'w-full pt-2 pb-2-8 md:pt-0 pb-0 flex flex-col justify-center items-center text-center'}>
              <Snippets.Heading
                size={window.innerWidth < 768 ? 'h2' : 'h1'}
                tag={'p'}
                className={'mb-1-6 md:mb-2-4'}
              >
                {title}
              </Snippets.Heading>
              <Snippets.Heading
                size={'p'}
                tag={'p'}
                className={'flex-1'}
              >
                <Snippets.RichText size={'p'} className={'leading-close'}>
                  {content}
                </Snippets.RichText>
              </Snippets.Heading>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  public setFormField = (key: string, value: string) => {
    this.setState((prevState) => ({
      form: {
        ...prevState.form,
        [key]: value,
      },
    }));
  }

  public submitForm = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!this.state.form.first_name || !this.state.form.last_name || !this.state.form.postcode || !this.state.form.city || !this.state.form.province || !this.state.form.mobile || !this.state.form.accept_terms) {
      return;
    }

    await axios.post("https://cors.bridged.cc/https://r3-api.dotmailer.com/v2/contacts", {
      "email": this.state.form.email,
      "optInType": "Single",
      "emailType": "Html",
      "dataFields": [
        {
          "key": "FIRSTNAME",
          "value": this.state.form.first_name.trim(),
        },
        {
          "key": "FULLNAME",
          "value": `${this.state.form.first_name ?? ""} ${this.state.form.last_name ?? ""}`.trim()
        },
        {
          "key": "LASTNAME",
          "value": this.state.form.last_name.trim(),
        },
        {
          "key": "BILLING_POSTCODE",
          "value": this.state.form.postcode.trim(),
        },
        {
          "key": "BILLING_CITY",
          "value": this.state.form.city.trim(),
        },
        {
          "key": "BILLING_STATE",
          "value": this.state.form.province.trim(),
        },
        {
          "key": "BILLING_COUNTRY",
          "value": "Australia"
        },
        {
          "key": "MOBILENUMBER",
          "value": this.state.form.mobile.trim(),
        },
        {
          "key": "TAG",
          "value": this.props.section.settings.competitionidentifier ?? "",
        }
      ],
      "status": "Subscribed"
    }, {
      auth: {
        username: "apiuser-ad4cd00722c1@apiconnector.com",
        password: "fV-Q9FnTD!kBdZRPs27r",
      },
      headers: {
        "x-requested-with": "shopify"
      },
    }).catch((error) => {
      console.log(error)
    })

    this.setState({
      popup: this.props.section.settings.competitionclosed ? "closed" : "thanks",
      form: {
        first_name: "",
        last_name: "",
        email: "",
        mobile: "",
        city: "",
        province: "",
        postcode: "",
      },
    });
  }

  public renderForm(): JSX.Element {
    const { section, data } = this.props
    const { settings, blocks } = section
    return (
      <form onSubmit={this.submitForm}>
        <div className={'block mb-4 sm:mb-6-4'}>
          <Snippets.Input
            type="text"
            hideLabel
            className={'mb-1-6 border border-grey-border'}
            placeholder="First name"
            onChange={(event) => this.setFormField("first_name", event.target.value)}
            value={this.state.form.first_name}
            required
          />
          <Snippets.Input
            type="text"
            hideLabel
            className={'mb-1-6 border border-grey-border'}
            placeholder="Last name"
            onChange={(event) => this.setFormField("last_name", event.target.value)}
            value={this.state.form.last_name}
            required
          />
          <Snippets.Input
            type="email"
            hideLabel
            className={'mb-1-6 border border-grey-border'}
            placeholder="Email address"
            onChange={(event) => this.setFormField("email", event.target.value)}
            value={this.state.form.email}
            required
          />
          <Snippets.Input
            type="tel"
            hideLabel
            className={'mb-1-6 border border-grey-border'}
            placeholder="Phone number"
            onChange={(event) => this.setFormField("mobile", event.target.value)}
            value={this.state.form.mobile}
            required
          />
          <div className={'flex flex-col md:flex-row w-full'}>
            <Snippets.Input
              className={'mb-1-6 border border-grey-border'}
              hideLabel
              id="city"
              type="text"
              placeholder="City"
              onChange={(event) => this.setFormField("city", event.target.value)}
              value={this.state.form.city}
              required
            />

            {(window as any).Countries?.Australia?.provinces && (
              <div className={'mb-1-6 w-full md:mx-0-8 h-4-8 border border-grey-border'}>
                <div className={'w-full h-full relative'}>
                  <select
                    id="province"
                    className={'w-full h-full pl-1-6 appearance-none bg-white'}
                    onChange={(event) => this.setFormField("province", event.target.value)}
                    value={this.state.form.province}
                    required
                  >
                    <option value="" disabled selected>Select state</option>
                    {(window as any).Countries.Australia.provinces.map(
                      (state: any): JSX.Element => (
                        <option key={state} value={state}>
                          {state == 'Australian Capital Territory' ? 'ACT' : state}
                        </option>
                      )
                    )}
                  </select>
                  <span className={'absolute'} style={{ right: '16px', top: '15px' }}>
                    <Snippets.Icon name="chevron_down" width={12} height={18} />
                  </span>
                </div>
              </div>
            )}

            <Snippets.Input
              className={'mb-1-6 border border-grey-border'}
              hideLabel
              id="postcode"
              type="number"
              placeholder="Postcode"
              onChange={(event) => this.setFormField("postcode", event.target.value)}
              value={this.state.form.postcode}
              required
            />
          </div>
          <div className={'mb-2'} onClick={(e) => this.setState((prevState) => ({ acceptsMarketing: !prevState.acceptsMarketing }))}>
            <label
              htmlFor="accepts_marketing"
              className={'block text-navy text-xs md:text-sm flex flex-row items-center'}
              onClick={(event) => this.setFormField("accept_terms", this.state.form.accept_terms ? "" : "yes" )}
            >
              <input
                id="accepts_marketing"
                type="hidden"
                value={this.state.form.accept_terms === "yes" ? "true" : "false"}
                required
              />
              <Snippets.Icon className={'mr-1-2'} name={this.state.acceptsMarketing ? 'checkbox_yes' : 'checkbox_no'} height={20} width={20}></Snippets.Icon>
              <Snippets.Heading size={'p'} tag={'p'} className={'leading-normal'}>
                <Snippets.RichText size={'p'} className={'leading-close'}>
                  {section.settings.termsandconditionscontent}
                </Snippets.RichText>
              </Snippets.Heading>
            </label>
          </div>
          <div className={'flex mb-0-6'}>
            <Snippets.Button
              title={'Submit'}
              type={'submit'}
              className={'w-full uppercase py-0-8 flex items-center'}
            >
              <span className={'flex-1 text-left'}>{section.settings.buttoncontent}</span>
              <Snippets.Icon name={'arrow_right'} width={40} />
            </Snippets.Button>
          </div>
        </div>
      </form>
    );
  }

  public render(): JSX.Element {
    const { section, data } = this.props
    const { settings, blocks } = section

    return (
      <>
        {this.state.popup === "thanks" && this.renderPopup(section.settings.popupthankstitle, section.settings.popupthankscontent)}
        {this.state.popup === "closed" && this.renderPopup(section.settings.popupclosedtitle, section.settings.popupclosedcontent)}
        <section className={'dynamic-competition py-4'}>
          <div className={'mx-1-6 mx-auto pb-19 flex flex-col items-center align-center'}>
            <div className={'w-full md:px-4-8 lg:px-0 lg:w-1/2'}>
              <div className={'w-full md:w-narrow mx-auto px-2 md:px-1'}>
                <Snippets.RichText size={'p'} className={'w-95 mx-auto leading-close mb-4'}>
                  {section.settings.descriptioncontent}
                </Snippets.RichText>
              </div>
              <div id="dynamic-competition" />
            </div>
          </div>
        </section>
      </>
    )
  }
}

export namespace DynamicCompetition {
  export interface Options extends ShopifyNext.Section<{
    competitionidentifier?: string;
    competitionclosed?: boolean;

    bannercontent?: string;
    buttoncontent?: string;
    descriptioncontent?: string;
    termsandconditionscontent?: string;
    
    popupthankstitle?: string;
    popupthankscontent?: string;
    
    popupclosedtitle?: string;
    popupclosedcontent?: string;
  }> {}
  export interface Props extends GlobalProps {
    section: DynamicCompetition.Options;
  }
  export interface State {
    popup: "none" | "thanks" | "closed";
    acceptsMarketing: boolean;
    form: {
      [key: string]: string;
    }
  }
}
